import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ClFormGroup extends Vue {
  /**
   * Display children in a compact row.
   */
  @Prop({
    type: Boolean,
    default: false
  })
  public row!: boolean;
}
